import { Dialog, DialogContent, DialogTitle, MenuItem } from "@mui/material";
import { ReactElement } from "react";

import { IntegrationServiceType } from "~frontend/__generated__/graphql";
import DialogCloseButton from "~frontend/components/DialogCloseButton";
import Select from "~frontend/components/forms/FormSelect";

import {
  IntegrationComponentType,
  IntegrationType,
  integrationComponents,
  integrationLabels,
} from "./types";

export function EditIntegrationDialog<T extends IntegrationServiceType>({
  integration,
  onClose,
  subaccountId,
}: {
  integration: IntegrationType<T> | null;
  onClose: () => void;
  subaccountId: string;
}): ReactElement {
  const open = !!integration;
  if (!open) {
    return <Dialog open={false} />;
  }

  const service = integration.service as T;

  const IntegrationComponent: IntegrationComponentType<T> =
    integrationComponents[service];

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Integration</DialogTitle>
      <DialogContent sx={{ minWidth: "400px" }}>
        <DialogCloseButton onClose={onClose} />
        <Select value={service} fullWidth disabled label="Service Provider">
          <MenuItem key={service} value={service}>
            {integrationLabels[service]}
          </MenuItem>
        </Select>
        <IntegrationComponent
          subaccountId={subaccountId}
          integration={integration}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
